import React from 'react';

import { JRCDate } from 'components/JRCDate/JRCDate';
import { isToday, isYesterday } from 'utils/utils.date';
import { JRCTypography } from 'components/JRCTypography/JRCTypography';

export const WidgetEmailsImapDate = ({ date, read }: { date: string; read: boolean }) => {
    const today = isToday(date);
    const yesterday = isYesterday(date);
    return (
        <JRCTypography weight="medium" size={'xs'} color={read ? 'grey4' : 'grey6'}>
            <JRCDate date={date} smartDate={today || yesterday ? true : false} format={today ? 'time' : 'date-time'} />
        </JRCTypography>
    );
};
